import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=e43c0ce6"
import script from "./Receipt.vue?vue&type=script&lang=ts"
export * from "./Receipt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports